import { render, staticRenderFns } from "./bidList.vue?vue&type=template&id=20e6730b&scoped=true"
import script from "./bidList.vue?vue&type=script&lang=js"
export * from "./bidList.vue?vue&type=script&lang=js"
import style0 from "./bidList.vue?vue&type=style&index=0&id=20e6730b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6730b",
  null
  
)

export default component.exports